import { useWidgetViewModel } from '../Widget/hooks/useWidgetViewModel';

export const useLayoutPerBpInWidget = () => {
  const { shouldWorkWithAppSettings } = useWidgetViewModel();
  return {
    layoutStylePerBpEnable: !shouldWorkWithAppSettings,
    layoutPbpPhase2Enabled: !shouldWorkWithAppSettings,
  };
};
